const columns = [
  {
    name: 'Incident Name',
    selector: (row) => row?.incidentname_tx,
    sortable: true,
    sortField: 'incidentname_tx',
  },
  {
    name: 'Incident Description ',
    selector: (row) => row?.description_tx,
    sortable: true,
    sortField: 'description_tx',
  },
  {
    name: 'Reviewed By',
    selector: (row) => row?.user_who_changed_status_name_tx,
    sortable: true,
    sortField: 'user_who_changed_status_name_tx',
  },
  {
    name: 'Created In',
    selector: (row) => row?.group_name_tx,
    sortable: true,
    sortField: 'group_name_tx',
  }, 
  
];
const mobileColumns = [
  {
    name: 'Incident Name',
    selector: (row) => row?.incidentname_tx,
    sortable: true,
    sortField: 'incidentname_tx',
  },
  {
    name: 'Incident Description',
    selector: (row) => row?.description_tx,
    sortable: true,
    sortField: 'description_tx',
  },
];

export { columns, mobileColumns };
